import { cn } from "@/shared/utils/style.util";

// Structure commune des CTA « recommander » du parrainage : pill, shimmer
// (.sponsorship-cta), typo et micro-interaction — la teinte est ajoutée par
// chaque variante ci-dessous.
const SPONSORSHIP_CTA_BASE = cn(
  "sponsorship-cta",
  "relative overflow-hidden",
  "inline-flex items-center gap-2 rounded-full px-[18px] py-[9px]",
  "text-[13px] font-semibold text-white whitespace-nowrap",
  "transition-all duration-[250ms] ease-out hover:-translate-y-px",
);

// Bouton du header global : il NAVIGUE vers le parrainage. Gradient violet,
// cohérent avec la grande carte hero du dashboard.
export const SPONSORSHIP_CTA_CLASS = cn(
  SPONSORSHIP_CTA_BASE,
  "bg-[linear-gradient(135deg,#6864ff,#7b36ec,#2397f2)]",
  "hover:shadow-[0_4px_18px_rgba(107,108,224,0.4)]",
);

// CTA in-page (barre d'onglets) : il OUVRE le formulaire de création. Teinte
// émeraude/teal distincte du header pour signaler une action différente, tout
// en restant dans la palette parrainage.
export const SPONSORSHIP_CTA_CREATE_CLASS = cn(
  SPONSORSHIP_CTA_BASE,
  "bg-[linear-gradient(135deg,#059669,#0d9488)]",
  "hover:shadow-[0_4px_18px_rgba(5,150,105,0.4)]",
);
